import { Module, TriggerBody } from "types/type.module";

/*
  @function ElementLabelText
  render label for Element
  @param chapter {number} chpater order number
  @param question {number} question order number
  @param answer {number} answer order number
  @param conclusion {boolean} element is conclusion
*/
export default function ElementLabel({
  chapter,
  question,
  answer,
  conclusion,
}: {
  chapter: number;
  question?: number;
  answer?: number;
  conclusion?: boolean;
}) {
  let identifier = "chapter";
  if (question && !isNaN(question)) identifier = "Q";
  if (answer && !isNaN(answer)) identifier = "A";
  if (conclusion) identifier = "C";
  return (
    <h2 className="text-2xl">{`${identifier}.${chapter}${
      question && !isNaN(question) ? "." + question : ""
    }${answer && !isNaN(answer) ? "." + answer : ""}`}</h2>
  );
}

/*
  @function ElementLabelText
  render label for Element
  @param chapter {number} chpater order number
  @param question {number} question order number
  @param answer {number} answer order number
  @param conclusion {boolean} element is conclusion
*/
export function ElementLabelText({
  chapter,
  question,
  answer,
  conclusion,
}: {
  chapter: number;
  question: number;
  answer?: number;
  conclusion?: boolean;
}) {
  let identifier = "chapter";
  if (!isNaN(question)) identifier = "Q";
  if (answer && !isNaN(answer)) identifier = "A";
  if (conclusion) identifier = "C";
  return `${identifier}.${chapter}${!isNaN(question) ? "." + question : ""}${
    answer && !isNaN(answer) ? "." + answer : ""
  }`;
}

/*
  @function ElementLabelTextSearchElement
  render label for Element searching it
  @param trigger {object}
  @param module {object}
  @returns {string}
*/
export function resolveElementLabel(trigger: TriggerBody, module: Module) {
  let isConclusion = false;
  let chapter = undefined;
  let question = undefined;
  let answer = undefined;

  // TODO: module should have correct type
  module.chapters.forEach((c) => {
    if ("chapter" in trigger && c.chapter_id === trigger.chapter) {
      c.questions.forEach((q) => {
        if (q.question_id === trigger.question) {
          chapter = c.order_number;
          question = q.order_number;
          if (q.conclusion) {
            isConclusion = q.conclusion;
          }

          q.possible_answers.forEach((a) => {
            if (a.possible_answer_id === trigger.answer) {
              answer = a.order_number;
            }
          });
        }
      });
    }
  });

  let identifier = "chapter";
  if (question && !isNaN(question)) identifier = "Q";
  if (answer && !isNaN(answer)) identifier = "A";
  if (isConclusion) identifier = "C";
  return `${identifier}.${chapter}${
    question && !isNaN(question) ? "." + question : ""
  }${answer && !isNaN(answer) ? "." + answer : ""}`;
}
